import React from 'react';
import { Box } from '@mui/material';
import { color, radius, font } from './tokens';

/**
 * The ONLY second-level navigation in the app. Horizontal pill tabs.
 * Never a nested sidebar, never an accordion inside content.
 *
 * tabs: [{ key, label, count? }]   value: active key   onChange: (key) => void
 */
export default function PageTabs({ tabs = [], value, onChange }) {
  if (!tabs.length) return null;
  return (
    <Box
      role='tablist'
      sx={{
        display: 'flex',
        gap: 0.5,
        mb: 1.5,
        overflowX: 'auto',
        borderBottom: `1px solid ${color.border}`,
        pb: 0.75,
        '&::-webkit-scrollbar': { height: 4 },
        '&::-webkit-scrollbar-thumb': {
          background: color.border,
          borderRadius: 3,
        },
      }}>
      {tabs.map((t) => {
        const active = t.key === value;
        return (
          <Box
            key={t.key}
            role='tab'
            aria-selected={active}
            onClick={() => onChange && onChange(t.key)}
            sx={{
              ...font.label,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75,
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              userSelect: 'none',
              px: 1.5,
              py: 0.75,
              borderRadius: `${radius.md}px`,
              color: active ? color.accent : color.textMuted,
              bgcolor: active ? color.accentSoft : 'transparent',
              transition: 'background .12s, color .12s',
              '&:hover': {
                color: active ? color.accent : color.text,
                bgcolor: active ? color.accentSoft : color.surfaceAlt,
              },
            }}>
            {t.label}
            {t.count != null && (
              <Box
                component='span'
                sx={{
                  ...font.helper,
                  fontWeight: 700,
                  px: 0.6,
                  borderRadius: `${radius.pill}px`,
                  bgcolor: active ? color.accent : color.border,
                  color: active ? '#fff' : color.textMuted,
                }}>
                {t.count}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
}